import React, { useContext } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Page } from '../Components/Page';
import { Icons } from '../Docs/DocTypes';
import { TagSearchbox, ISearchArgs, TagIcon } from '@tag/tag-components-react-v3';
import { darkModeContext } from '../darkModeContext';

export const IconsPage = () => {
  const [criteria, setCriteria] = React.useState('');
  const dmContext = useContext(darkModeContext);
  return (
    <Page title="Icons">
      <div>
        <TagSearchbox
          placeholder="Search for icons ..."
          delay={0}
          onSearch={(e: CustomEvent<ISearchArgs>) => setCriteria(e.detail.criteria)}
          colourScheme={dmContext.value ? 'dark' : 'light'}
        />
        <div
          css={css`
            display: flex;
            flex-wrap: wrap;
            margin-top: 15px;
          `}
        >
          {Icons.filter(
            icon => criteria === '' || icon.toLowerCase().indexOf(criteria.toLowerCase()) > -1,
          ).map((icon, index) => (
            <div
              key={index}
              css={css`
                display: flex;
                align-items: center;
                width: 250px;
                height: 55px;
              `}
            >
              <TagIcon icon={icon} size={40} colourScheme={dmContext.value ? 'dark' : 'light'} />
              <span
                css={css`
                  margin-left: 5px;
                `}
              >
                {icon}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
};
